import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Lock, Mail, ShieldCheck, Building2, Wrench, Bell } from "lucide-react";

const GROUPS = [
  { key: "manufacturers", icon: Building2, title: "Fabricants (ex. Samsung)", fields: [
    ["model", "Modèle"], ["serial", "Numéro de série"], ["sav_history", "Historique SAV autorisé"],
    ["personal_docs", "Documents personnels"], ["other_equipment", "Autres équipements"], ["insurance", "Contrats d'assurance"]] },
  { key: "insurers", icon: ShieldCheck, title: "Assureurs", fields: [
    ["contracts", "Contrats"], ["claims", "Sinistres"]] },
  { key: "repairers", icon: Wrench, title: "Réparateurs & installateurs", fields: [
    ["equipment", "Équipement concerné"], ["history", "Historique technique"], ["personal_docs", "Documents personnels"]] },
];

export default function Confidentialite() {
  const { user } = useAuth();
  const [consents, setConsents] = useState(null);

  useEffect(() => { api.get("/privacy/consents").then((r) => setConsents(r.data.consents)); }, []);

  const toggle = (group, field) => {
    const next = { ...consents, [group]: { ...consents[group], [field]: !consents[group]?.[field] } };
    setConsents(next);
  };
  const toggleFlat = (key) => setConsents({ ...consents, [key]: !consents[key] });

  const save = async () => { await api.put("/privacy/consents", { consents }); toast.success("Préférences enregistrées"); };

  if (!consents) return <div className="text-muted-foreground">Chargement…</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Confidentialité</h1>
        <p className="text-muted-foreground text-sm mt-1">Privacy Center — tu choisis qui voit quoi. Permissions granulaires et révocables. Ta donnée brute n'est jamais le produit.</p>
      </div>

      <div className="omy-glass rounded-2xl p-5 flex items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-accent/15 flex items-center justify-center"><Mail size={18} className="text-accent" /></div>
        <div className="min-w-0">
          <p className="text-xs text-muted-foreground">Ton adresse OMY Inbox (donne-la aux commerçants au lieu de ton email perso)</p>
          <p className="font-mono text-sm truncate" data-testid="omy-inbox-value">{user?.omy_inbox}</p>
        </div>
      </div>

      {GROUPS.map((g) => (
        <div key={g.key} className="omy-glass rounded-2xl p-6" data-testid={`consent-group-${g.key}`}>
          <div className="flex items-center gap-2 mb-4"><g.icon size={18} className="text-primary" />
            <h2 className="font-display font-medium">{g.title}</h2></div>
          <div className="space-y-3">
            {g.fields.map(([f, label]) => (
              <div key={f} className="flex items-center justify-between">
                <span className="text-sm">{label}</span>
                <Switch data-testid={`consent-${g.key}-${f}`} checked={!!consents[g.key]?.[f]} onCheckedChange={() => toggle(g.key, f)} />
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="omy-glass rounded-2xl p-6">
        <div className="flex items-center gap-2 mb-4"><Bell size={18} className="text-primary" /><h2 className="font-display font-medium">Propositions commerciales</h2></div>
        {[["marketing", "Recevoir des propositions partenaires"], ["reconditioning_offers", "Offres de reprise / reconditionnement"]].map(([k, label]) => (
          <div key={k} className="flex items-center justify-between py-1.5">
            <span className="text-sm">{label}</span>
            <Switch data-testid={`consent-flat-${k}`} checked={!!consents[k]} onCheckedChange={() => toggleFlat(k)} />
          </div>
        ))}
      </div>

      <Button data-testid="consent-save-btn" onClick={save} className="bg-primary hover:bg-primary/90 rounded-full">
        <Lock size={16} className="mr-1.5" /> Enregistrer mes préférences
      </Button>
    </div>
  );
}
